export const DOCUMENT_TYPE_DNI = {
  id: 2,
  label: "DNI",
  value: "2",
  minLength: 8,
  maxLength: 8,
  errorMessage: "*Deben ser 8 digitos numéricos",
};

export const DOCUMENT_TYPE_CE = {
  id: 4,
  label: "CE",
  value: "4",
  minLength: 9,
  maxLength: 11,
  errorMessage: "*Deben ser entre 9 y 11 caracteres alfanuméricos",
};

export const DOCUMENT_TYPE_RUC = {
  id: 1,
  label: "RUC",
  value: "1",
  minLength: 11,
  maxLength: 11,
  errorMessage: "*Deben ser 11 digitos numéricos",
};

export const LIST_DOCUMENT_TYPE = [
  DOCUMENT_TYPE_DNI,
  DOCUMENT_TYPE_CE,
  DOCUMENT_TYPE_RUC,
];

export const getDocumentType = (value) => LIST_DOCUMENT_TYPE.find((item) => item.value === value);